import angular from "angular";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import {
  ReportingServer,
  vsName as ReportingServerName,
} from "../../../../reporting/server";
import { MachineConfigurationView } from "../../models/machineConfiguration";
import { vsComponentName as MachinesChangeViewComponentOptionsName } from "./component";

export const vsServiceName = "MachinesChangeViewModalService";

export interface MachinesChangeViewModalOptions {}

export class MachinesChangeViewModalService {
  static $inject = ["$uibModal"];
  constructor(private readonly $uibModal: angular.ui.bootstrap.IModalService) {}

  openModal(ChangeId?: string) {
    var popup = this.$uibModal.open({
      component: MachinesChangeViewComponentOptionsName,
      resolve: {
        machineConfigurations: [
          ServerUtilityName,
          (serverUtility: ServerUtility) =>
            serverUtility.fetchAll<MachineConfigurationView>({
              url: "/api/machines/MachineConfiguration",
              query: { ChangeId },
            }),
        ],
        ChangeId: () => ChangeId,
        reportGroup: [
          ReportingServerName,
          (reportingServer: ReportingServer) =>
            reportingServer.getReportGroup("machine"),
        ],
      },
    });

    return popup;
  }
}
